export const REACT_QUERY_DB_NAME = 'scalar:react-query';
export const REACT_QUERY_DB_VERSION = 1;
export const REACT_QUERY_STORE_NAME = 'entries';
export const REACT_QUERY_CACHE_KEY = 'reactQuery';
export const REACT_QUERY_FALLBACK_STORAGE_KEY = 'scalar:react-query:cache';
export const REACT_QUERY_CACHE_SCHEMA_VERSION = 1;
